import { store } from '../../redux/store';
import { ICandidate, ISharedLinks } from 'core/interface/candidate';
import ApiBase from 'services/base/apiBase';
import {
  AddCandidatesVideos,
  DeleteCandidateVideos,
  SaveCandidates,
  SaveCandidatesOverwie,
  SaveCandidatesSharedLinks
} from '../../redux/slices/candidates';
import { SaveCandidate } from '../../redux/slices/candidate';

export class CandidateService {
  private static readonly apiURL = new ApiBase<ICandidate>();

  /** PATCH responses may omit fields like report_urls; keep existing values. */
  public static saveCandidateFromPatch(res: ICandidate): void {
    const { dispatch } = store;
    const currentCandidate = store.getState().candidate?.candidate;

    dispatch(
      SaveCandidate(
        currentCandidate
          ? {
              ...currentCandidate,
              ...res,
              report_urls: res.report_urls ?? currentCandidate.report_urls
            }
          : res
      )
    );
  }

  public static async getCandidate(
    candidate_id: number
  ): Promise<ICandidate | void> {
    const { dispatch } = store;
    try {
      const res = await this.apiURL.getAsync(`/candidates/${candidate_id}/`);
      dispatch(SaveCandidates(res));
      dispatch(SaveCandidate(res));
      return res;
    } catch (error) {
      console.error('Error fetching candidate:', error);
    }
  }

  public static async updateCandidate(
    body: object,
    candidate_id: number
  ): Promise<ICandidate | null> {
    const { dispatch } = store;
    try {
      const res = await this.apiURL.updateAsync(
        `/candidates/${candidate_id}/`,
        body
      );
      dispatch(SaveCandidates(res));
      this.saveCandidateFromPatch(res);
      return res;
    } catch (error) {
      console.log(error);
      return null;
    }
  }

  public static async getCandidateOverview(
    candidate_id: number
  ): Promise<ICandidate> {
    const { dispatch } = store;
    const res = await this.apiURL.getAsync(
      `/candidates/overview/${candidate_id}/`
    );
    dispatch(SaveCandidatesOverwie(res));
    return res;
  }

  public static async getSharedLinks(id: number): Promise<Array<ISharedLinks>> {
    const { dispatch } = store;
    const res = await this.apiURL.getAsync(`/candidates/${id}/shared-links/`);
    dispatch(SaveCandidatesSharedLinks(res));
    return res
  }

  public static async saveSharedLinks(id: number, body: { title?: string, url: string }): Promise<ISharedLinks> {
    const { dispatch } = store;
    const res = await this.apiURL.postAsync(
      `/candidates/${id}/shared-links/`,
      body
    );
    dispatch(AddCandidatesVideos(res));
    return res;
  }

  public static async deleteSharedLinks(candidateId: number, sharedLinksId: number): Promise<boolean> {
    const { dispatch } = store
    const res = await this.apiURL.deleteAsync(`/candidates/${candidateId}/shared-links/${sharedLinksId}/`)
    dispatch(DeleteCandidateVideos(sharedLinksId));
    return res;
  }
}
